<template>
    <v-dialog v-model="isView">
        <v-card class="mt-3 pa-1">
            <Title title="撮影画像の選択">
                <v-spacer />
                <TitleButton
                    v-if="selectedImages.length > 0"
                    @click="onClickSet"
                    color="primary"
                    icon="mdi-camera"
                    name="決定" />
                <TitleButton
                    color="primary"
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <Camera isSelectMode @onSelectedImages="onSelectedImages" />
        </v-card>
    </v-dialog>    
</template>

<script>
    import Camera from '@/components/camera/Camera';
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        components: {
            Camera,
            Title,
            TitleButton
        },
        data: function () {
            return {
                isView: false,
                selectedImages: []
            }
        },
        methods: {
            onSelectedImages: function (images) {
                console.log("onSelectedImages", images)
                this.selectedImages = images
            },
            onClickSet: function () {
                this.$emit("onSelectedUncategorizedImages", this.selectedImages)
                this.isView = false
            },
            show: function () {
                this.isView = true
            }
        }
    }
</script>
